import { WebPlugin } from '@capacitor/core';
export class MetaAdsWeb extends WebPlugin {
    async initialize(options) {
        console.log('MetaAds Web: initialize', options);
        // Web implementation not available for Meta Audience Network
        throw new Error('Meta Audience Network is not available on web platform');
    }
    async loadRewardedVideo(options) {
        console.log('MetaAds Web: loadRewardedVideo', options);
        throw new Error('Meta Audience Network is not available on web platform');
    }
    async showRewardedVideo() {
        console.log('MetaAds Web: showRewardedVideo');
        throw new Error('Meta Audience Network is not available on web platform');
    }
    async isRewardedVideoLoaded() {
        console.log('MetaAds Web: isRewardedVideoLoaded');
        return { loaded: false };
    }
    async loadInterstitial(options) {
        console.log('MetaAds Web: loadInterstitial', options);
        throw new Error('Meta Audience Network is not available on web platform');
    }
    async showInterstitial() {
        console.log('MetaAds Web: showInterstitial');
        throw new Error('Meta Audience Network is not available on web platform');
    }
    async isInterstitialLoaded() {
        console.log('MetaAds Web: isInterstitialLoaded');
        return { loaded: false };
    }
    async setTestMode(options) {
        console.log('MetaAds Web: setTestMode', options);
        // No-op on web
    }
    async addTestDevice(options) {
        console.log('MetaAds Web: addTestDevice', options);
        // No-op on web
    }
}
//# sourceMappingURL=web.js.map